import { ArrowUp } from "lucide-react";
import LogoMark from "./LogoMark";
import { useSmoothScroll } from "../context/ScrollContext";

const Footer = () => {
  const { scrollTo } = useSmoothScroll();

  return (
    <footer data-testid="footer-section" className="bg-[#241541] text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <LogoMark dark className="h-10 w-10" />
              <span data-testid="footer-logo-mark" className="leading-none">
                <span className="block font-heading font-extrabold tracking-tight text-lg">
                  Tri Valley
                </span>
                <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-[#B9AED6] mt-0.5">
                  Community Doula Services
                </span>
              </span>
            </div>
            <p className="text-sm text-[#B9AED6] leading-relaxed max-w-xs">
              Full-spectrum doula care and maternal health coaching, grounded in
              advocacy and carried by community.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] font-heading font-bold text-[#F2644C] mb-5">
              Explore
            </p>
            <div className="flex flex-col gap-3">
              {[
                { label: "Services", hash: "#services", testid: "footer-link-services" },
                { label: "Pricing", hash: "#pricing", testid: "footer-link-pricing" },
                { label: "About Adonica", hash: "#about", testid: "footer-link-about" },
                { label: "Service Area", hash: "#service-area", testid: "footer-link-area" },
                { label: "Contact", hash: "#contact", testid: "footer-link-contact" },
              ].map((l) => (
                <button
                  key={l.hash}
                  data-testid={l.testid}
                  onClick={() => scrollTo(l.hash)}
                  className="text-left text-sm font-medium text-[#B9AED6] hover:text-white transition-colors w-fit"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] font-heading font-bold text-[#F2644C] mb-5">
              Visit &amp; connect
            </p>
            <p className="text-sm text-[#B9AED6] mb-2">
              Tracy, California, serving San Joaquin County
            </p>
            <a
              data-testid="footer-phone-text"
              href="tel:+12094255979"
              className="block text-sm text-[#B9AED6] hover:text-white transition-colors mb-2 w-fit"
            >
              209-425-5979
            </a>
            <a
              href="mailto:hello@sageandseabirth.com"
              className="text-sm text-[#B9AED6] hover:text-white transition-colors"
            >
              hello@sageandseabirth.com
            </a>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10">
          <p
            data-testid="footer-dba-legal-text"
            className="text-xs text-[#8E82AC] leading-relaxed mb-6 max-w-2xl"
          >
            Sage &amp; Sea Birth Services LLC is doing business as (DBA) Tri
            Valley Community Doula Services. Providing comprehensive maternal
            health advocacy, childbirth education, and full-spectrum doula care
            across San Joaquin County.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
            <p className="text-xs text-[#8E82AC] tracking-wide">
              © 2026 Tri Valley Community Doula Services. All rights reserved.
            </p>
            <button
              data-testid="footer-back-to-top-button"
              onClick={() => scrollTo(0)}
              className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-[#B9AED6] hover:text-white transition-colors group"
            >
              Back to top
              <span className="h-8 w-8 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-[#F2644C] group-hover:border-[#F2644C] transition-all duration-300">
                <ArrowUp className="h-3.5 w-3.5" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
